import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { ACTIONS, SOURCES } from 'reservations/preview/constants';
import { PreviewModeDataContextInterface } from 'reservations/preview/providers/PreviewModeProvider';

const usePreviewMode = (): PreviewModeDataContextInterface => {
  const [data, setData] = useState(null);
  const [origin, setOrigin] = useState<string | null>('');
  const [isPreview, setIsPreview] = useState(false);

  const handleEventMessage = (
    event: MessageEvent,
    callback: Dispatch<SetStateAction<null>>
  ) => {
    const { data, origin: eventOrigin } = event;

    // removing port out of domain
    // e.g. "https://domain.localtest.me:8000" | "https://domain.localtest.me:8080" -> "https://domain.localtest.me"
    const origin = eventOrigin.replace(/:*[0-9]/g, '');

    if (
      origin !== `https://${window.location.hostname}` ||
      data.source !== SOURCES.CMS_APPLICATION
    ) {
      return;
    }

    callback(data.context);
  };

  const sendMessageToParent = (
    origin: string,
    action: string,
    context?: string
  ) => {
    window.parent.postMessage(
      {
        source: SOURCES.PREVIEW_APPLICATION,
        action,
        context
      },
      origin
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    setOrigin(searchParams.get('origin'));
    setIsPreview(
      searchParams.has('brandPreview') || searchParams.has('preDiningPreview')
    );
  }, []);

  useEffect(() => {
    const eventHandler = (event: MessageEvent) =>
      handleEventMessage(event, setData);

    if (origin) {
      window.addEventListener('message', eventHandler);
      sendMessageToParent(origin, ACTIONS.PREVIEW_LOADED);
    }

    return () => window.removeEventListener('message', eventHandler);
  }, [origin]);

  return {
    previewData: data,
    isPreview
  };
};

export default usePreviewMode;
